import { createAppWithCoreComponents } from "./registerCoreModules";
import { createPcPage } from "_Main/_page";
import { getStyleImportForGoogleFont } from "ProgramAdmin/Themes/fontUtils";

import "Styles/pci/style-sheet.scss";

//including this here and not on registerCoreMudles since we do not need this component in the versaform/embed contexts.
import pageLayout from "Components/page/pc-page-layout.vue";
import pageHeader from "Components/page/pc-page-header.vue";

const cssThemeKey = "pc-theme-preview";

function bootstrapPowerClerk(controllerComponent) {
    const cssPreviewPayload = localStorage.getItem(cssThemeKey);

    if (cssPreviewPayload) {
        const previewCss = JSON.parse(cssPreviewPayload);
        const baseCss = previewCss.base;
        const fontFamily = previewCss.variables.fontFamily;
        const stylesheet = new CSSStyleSheet();
        stylesheet.replaceSync(baseCss);
        document.adoptedStyleSheets = [stylesheet];

        const styleblock = document.createElement("style");
        styleblock.innerText = getStyleImportForGoogleFont(fontFamily);
        document.body.append(styleblock);
    }

    function createPowerClerkApp(props, mountSelector) {
        const vueRoot = createAppWithCoreComponents(controllerComponent, props, createPcPage);
        vueRoot.component("pc-page-header", pageHeader);
        vueRoot.component("pc-page-layout", pageLayout);
        vueRoot.mount(mountSelector);
    }

    if (window) {
        // Expose createPowerClerkApp to the global context so that we can actually
        // instantiate the main Vue component in _LoggedInVue.cshtml, _AnonVue.cshtml, _Homepage.cshtml
        window.createPowerClerkApp = createPowerClerkApp;
    }
}

export { cssThemeKey, bootstrapPowerClerk };
